import { render, staticRenderFns } from "./WorkspaceLinksTab.vue?vue&type=template&id=60132a86&scoped=true"
import script from "./WorkspaceLinksTab.vue?vue&type=script&lang=js"
export * from "./WorkspaceLinksTab.vue?vue&type=script&lang=js"
import style0 from "./WorkspaceLinksTab.vue?vue&type=style&index=0&id=60132a86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60132a86",
  null
  
)

export default component.exports